export const environment = {
  production: false,
  baseApiSpeedpresta: 'https://api.speedpresta.com/api/v1/',
  platformSiteUrl: 'SITE/RETRIEVE_ALL_FROM_KEY',
  configRetrieveUrl: 'CONFIG/RETRIEVE_FROM_KEY',
  configUpdateUrl: 'CONFIG/UPDATE_ALL',
  configCreateUrl: 'CONFIG/CREATE',
  tablesRetrieveUrl: 'RESERVATIONS_TABLE/RETRIEVE_ALL_FROM_KEY',
  tablesCreateUrl: 'RESERVATIONS_TABLE/CREATE',
  tablesUpdateUrl: 'RESERVATIONS_TABLE/UPDATE_ALL',
  tablesDeleteUrl: 'RESERVATIONS_TABLE/DELETE',
  zonesRetrieveUrl: 'RESERVATIONS_ZONE/RETRIEVE_ALL_FROM_KEY',
  zonesCreateUrl: 'RESERVATIONS_ZONE/CREATE',
  zonesUpdateUrl: 'RESERVATIONS_ZONE/UPDATE_ALL',
  zonesDeleteUrl: 'RESERVATIONS_ZONE/DELETE',
  bookingsRetrieveUrl: 'RESERVATIONS_BOOKING/RETRIEVE_ALL_FROM_KEY',
  bookingsCreateUrl: 'RESERVATIONS_BOOKING/CREATE',
  bookingsUpdateUrl: 'RESERVATIONS_BOOKING/UPDATE_ALL',
  bookingsDeleteUrl: 'RESERVATIONS_BOOKING/DELETE',
  vehiclesRetrieveUrl:        'RESERVATIONS_VEHICLE/RETRIEVE_ALL_FROM_KEY',
  vehiclesCreateUrl:          'RESERVATIONS_VEHICLE/CREATE',
  vehiclesUpdateUrl:          'RESERVATIONS_VEHICLE/UPDATE_ALL',
  vehiclesDeleteUrl:          'RESERVATIONS_VEHICLE/DELETE',
  vehicleBookingsRetrieveUrl: 'RESERVATIONS_VEHICLE_BOOKING/RETRIEVE_ALL_FROM_KEY',
  vehicleBookingsCreateUrl:   'RESERVATIONS_VEHICLE_BOOKING/CREATE',
  vehicleBookingsUpdateUrl:   'RESERVATIONS_VEHICLE_BOOKING/UPDATE_ALL',
  vehicleBookingsDeleteUrl:   'RESERVATIONS_VEHICLE_BOOKING/DELETE',
  roomsRetrieveUrl:         'RESERVATIONS_ROOM/RETRIEVE_ALL_FROM_KEY',
  roomsCreateUrl:           'RESERVATIONS_ROOM/CREATE',
  roomsUpdateUrl:           'RESERVATIONS_ROOM/UPDATE_ALL',
  roomsDeleteUrl:           'RESERVATIONS_ROOM/DELETE',
  roomBookingsRetrieveUrl:  'RESERVATIONS_ROOM_BOOKING/RETRIEVE_ALL_FROM_KEY',
  roomBookingsCreateUrl:    'RESERVATIONS_ROOM_BOOKING/CREATE',
  roomBookingsUpdateUrl:    'RESERVATIONS_ROOM_BOOKING/UPDATE_ALL',
  roomBookingsDeleteUrl:    'RESERVATIONS_ROOM_BOOKING/DELETE',
  apiUrl: 'http://localhost:3010',
};
